module.exports = __webpack_public_path__ + "static/img/smiling12.ef1b582.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smiling12.jpg
// module id = 180
// module chunks = 2